namespace GeniuzPOS.Lookups {
    export namespace VwpsShopService {
        export const baseUrl = 'Lookups/VwpsShop';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwpsShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwpsShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwpsShop/Retrieve",
            List = "Lookups/VwpsShop/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwpsShopService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
